import { Box3DIcon } from "../../components/icons/Box3DIcon";
import { TableIcon } from "../../components/icons/TableIcon";
import { ChartBarIcon } from "../../components/icons/ChartBarIcon";
import { ExternalLinkIcon } from "../../components/icons/ExternalLinkIcon";
import { ModelIcon } from "../../components/icons/ModelIcon";
import { BlockedIcon } from "../../components/icons/BlockedIcon";
import { ChevronDownIcon } from "../../components/icons/ChevronDownIcon";
import { LayoutStudioIcon } from "../../components/icons/LayoutStudioIcon";
import { QHSEIcon } from "../../components/icons/QHSEIcon";
import { AnalyticsIcon } from "../../components/icons/AnalyticsIcon";
import { ThreeDVisualizationIcon } from "../../components/icons/ThreeDVisualizationIcon";
import { DataExplorationIcon } from "../../components/icons/DataExplorationIcon";
import { HeaderButton } from "../../components/HeaderButton";
import avatarPlaceholder from "../../assets/images/avatar-placeholder.png";
import { useState } from "react";

// What's Next Data
const whatsNextData = [
  {
    id: 1,
    category: "worked",
    icon: (
      <div className="absolute inset-[12.5%]">
        <ModelIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "TS001-Topside — Version 5.0",
    subtitle: "Jaguar Project • Konnect Core — 3D Models",
    actionText: "New model version upload",
    time: "3 hours ago",
  },
  {
    id: 2,
    category: "worked",
    icon: (
      <div className="absolute aspect-[16/16] left-[16.67%] right-[16.67%] top-1/2 translate-y-[-50%]">
        <BlockedIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Blocked — PID-003-C — Blocked",
    subtitle: "Jaguar Project • P&ID Explorer — Data Exploration",
    actionText: "Requires review",
    time: "1 day ago",
  },
  {
    id: 13,
    category: "worked",
    icon: (
      <div className="absolute aspect-[92/92] left-[16.67%] right-[16.67%] rounded-[6px] top-1/2 translate-y-[-50%]">
        <img
          alt="User profile avatar"
          className="absolute inset-0 max-w-none object-center object-cover pointer-events-none rounded-[6px] size-full"
          src={avatarPlaceholder}
        />
      </div>
    ),
    title: "Engineering Maturity Index — 76%",
    subtitle: "Drivers: P&ID +3% (10 sheets), 3D +5% (v5.0)",
    actionText: "↑ +4% (7d)",
    time: "1 day ago",
  },
  {
    id: 14,
    category: "worked",
    icon: (
      <div className="absolute aspect-[92/92] left-[16.67%] right-[16.67%] rounded-[6px] top-1/2 translate-y-[-50%]">
        <img
          alt="User profile avatar"
          className="absolute inset-0 max-w-none object-center object-cover pointer-events-none rounded-[6px] size-full"
          src={avatarPlaceholder}
        />
      </div>
    ),
    title: "Workfront Ready — Spools — 42 / 43 erectable",
    subtitle: "Jaguar Project • 3D Visualization — Status Viz",
    actionText: "View blocking spool",
    time: "2 days ago",
  },
  {
    id: 15,
    category: "worked",
    icon: (
      <div className="absolute aspect-[92/92] left-[16.67%] right-[16.67%] rounded-[6px] top-1/2 translate-y-[-50%]">
        <img
          alt="User profile avatar"
          className="absolute inset-0 max-w-none object-center object-cover pointer-events-none rounded-[6px] size-full"
          src={avatarPlaceholder}
        />
      </div>
    ),
    title: "Material Allocation — 27 Identcodes not matched",
    subtitle: "Jaguar Project • 3D Visualization — PIMS Sync",
    actionText: "Resolve mapping",
    time: "2 days ago",
  },
  {
    id: 3,
    category: "viewed",
    icon: (
      <div className="absolute inset-[12.5%]">
        <ChartBarIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Readiness Heatmap — Piping/Spools — ↑ +5% WoW",
    subtitle: "Jaguar Project • Analytics",
    actionText: "Open dashboard",
    time: "5 min ago",
  },
  {
    id: 4,
    category: "viewed",
    icon: (
      <div className="absolute inset-[12.5%]">
        <Box3DIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Full FPSO Model — TS001 v5.0",
    subtitle: "Jaguar Project • 3D Visualization",
    actionText: "Open model",
    time: "30 min ago",
  },
  {
    id: 5,
    category: "viewed",
    icon: (
      <div className="absolute aspect-[18/18] left-[8.33%] right-[8.33%] top-[2px]">
        <TableIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Test Pack checklist — TP-662-L-2013",
    subtitle: "Jaguar Project • Data Exploration • 3D Visualization",
    actionText: "View items",
    time: "1 hour ago",
  },
  {
    id: 6,
    category: "viewed",
    icon: (
      <div className="absolute inset-[12.5%]">
        <ChartBarIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Piping BOM Variance — Δ -2.4% vs plan",
    subtitle: "Jaguar Project • 5D Cost Exploration",
    actionText: "Open report",
    time: "yesterday",
  },
  {
    id: 7,
    category: "viewed",
    icon: (
      <div className="absolute aspect-[18/18] left-[8.33%] right-[8.33%] top-[2px]">
        <ChartBarIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Lineage — VESE family — 18 downstream refs",
    subtitle: "Jaguar Project • Data Exploration — Graph",
    actionText: "View graph",
    time: "yesterday",
  },
  {
    id: 8,
    category: "recommended",
    icon: (
      <div className="absolute inset-[12.5%]">
        <Box3DIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Prioritize erectable spools — 8 spools ready now",
    subtitle: "Jaguar Project • 3D Visualization — Status Viz",
    actionText: "Create work package",
    time: "Just now",
  },
  {
    id: 9,
    category: "recommended",
    icon: (
      <div className="absolute inset-[12.5%]">
        <Box3DIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Run Status Viz after deliveries — 27 materials updated",
    subtitle: "Jaguar Project • 3D Visualization — PIMS Sync",
    actionText: "Run now",
    time: "1 hour ago",
  },
  {
    id: 10,
    category: "recommended",
    icon: (
      <div className="absolute aspect-[18/18] left-[8.33%] right-[8.33%] top-[2px]">
        <TableIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Create Test Pack for 662-L-2013 — Auto-grouped (4 spools)",
    subtitle: "Jaguar Project • Data Exploration • 3D Visualization",
    actionText: "Start pack",
    time: "3 hours ago",
  },
  {
    id: 11,
    category: "recommended",
    icon: (
      <div className="absolute inset-[12.5%]">
        <Box3DIcon className="block size-full text-[#292A2E]" />
      </div>
    ),
    title: "Fix QC failures on S-2201...S-2205 — 5 open",
    subtitle: "Jaguar Project • 3D Visualization — PDI/QHSE",
    actionText: "Assign rework",
    time: "1 day ago",
  },
  {
    id: 12,
    category: "recommended",
    icon: (
      <div className="absolute aspect-[92/92] left-[16.67%] right-[16.67%] rounded-[6px] top-1/2 translate-y-[-50%]">
        <img
          alt="User profile avatar"
          className="absolute inset-0 max-w-none object-center object-cover pointer-events-none rounded-[6px] size-full"
          src={avatarPlaceholder}
        />
      </div>
    ),
    title: "Enable SSO for Jaguar Project STG — Reduce invite friction",
    subtitle: "Konnect Core — Platform",
    actionText: "Open setup",
    time: "2 days ago",
  },
];

// Frequently Visited Card Component
function FrequentlyVisitedCard({
  icon,
  title,
  subtitle,
  link,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  link?: string;
}) {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (link && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="basis-0 grow min-h-px min-w-px relative shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Visit ${title}`}
    >
      <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
        <div className="box-border content-stretch flex gap-[12px] items-center p-[8px] relative w-full">
          <div className="basis-0 content-stretch flex gap-[12px] grow items-start min-h-px min-w-px relative shrink-0">
            <div className="content-stretch flex items-start relative shrink-0">
              <div className="overflow-clip relative shrink-0 size-[48px]">
                {icon}
              </div>
            </div>
            <div className="basis-0 content-stretch flex flex-col gap-[6px] grow items-start justify-center min-h-px min-w-px relative shrink-0">
              <div className="content-stretch flex gap-[12px] h-[24px] items-center relative shrink-0 w-full">
                <p
                  className="font-['Noto_Sans:Regular',sans-serif] font-normal leading-[20px] relative shrink-0 text-[#292a2e] text-[14px] text-nowrap whitespace-pre"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  {title}
                </p>
              </div>
              <div className="content-stretch flex flex-col gap-[4px] items-start justify-center relative shrink-0">
                <div
                  className="flex flex-col font-['SF_Pro:Regular',sans-serif] font-normal justify-center leading-[0] relative shrink-0 text-[#6b6e76] text-[12px] text-nowrap"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  <p className="leading-[16px] whitespace-pre">{subtitle}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="content-stretch flex items-start relative shrink-0">
            <div className="overflow-clip relative shrink-0 size-[24px]">
              <div className="absolute aspect-[18.0123/18.0123] left-[16.67%] right-[16.67%] top-1/2 translate-y-[-50%]">
                <ExternalLinkIcon className="block size-full text-[#292A2E]" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        className="absolute border border-[rgba(11,18,40,0.14)] border-solid inset-0 pointer-events-none"
      />
    </div>
  );
}

// What's Next Item Component
function WhatsNextItem({
  icon,
  title,
  subtitle,
  actionText,
  time,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  actionText: string;
  time: string;
}) {
  return (
    <div className="relative shrink-0 w-full">
      <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
        <div className="box-border content-stretch flex gap-[12px] items-center px-[16px] py-[12px] relative w-full">
          <div className="basis-0 content-stretch flex gap-[12px] grow items-center min-h-px min-w-px relative shrink-0">
            <div className="content-stretch flex items-start relative shrink-0">
              <div className="overflow-clip relative shrink-0 size-[24px]">
                {icon}
              </div>
            </div>
            <div className="basis-0 content-stretch flex flex-col gap-[6px] grow items-start justify-center min-h-px min-w-px relative shrink-0">
              <div className="content-stretch flex gap-[12px] h-[24px] items-center relative shrink-0 w-full">
                <p
                  className="font-['Noto_Sans:Regular',sans-serif] font-normal leading-[20px] relative shrink-0 text-[#292a2e] text-[14px] text-nowrap whitespace-pre"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  {title}
                </p>
              </div>
              <div className="content-stretch flex flex-col font-normal gap-[4px] items-start justify-center leading-[0] relative shrink-0 text-[12px] text-nowrap">
                <div
                  className="flex flex-col font-['SF_Pro:Regular',sans-serif] justify-center relative shrink-0 text-[#6b6e76]"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  <p className="leading-[16px] text-nowrap whitespace-pre">
                    {subtitle}
                  </p>
                </div>
                <div
                  className="flex flex-col font-['Noto_Sans:Regular',sans-serif] justify-center relative shrink-0 text-[#1558bc]"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  <p className="leading-[16px] text-nowrap whitespace-pre">
                    {actionText}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex flex-col font-['SF_Pro:Regular',sans-serif] font-normal justify-center leading-[0] relative shrink-0 text-[#6b6e76] text-[12px] text-nowrap"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="leading-[16px] whitespace-pre">{time}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Recent Project Card Component
function RecentProjectCard({
  title,
  subtitle,
  badge,
}: {
  title: string;
  subtitle: string;
  badge?: string;
}) {
  return (
    <div className="basis-0 grow min-h-px min-w-px relative shrink-0">
      <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
        <div className="box-border content-stretch flex gap-[12px] items-center p-[8px] relative w-full">
          <div className="basis-0 content-stretch flex gap-[12px] grow items-start min-h-px min-w-px relative shrink-0">
            <div className="basis-0 content-stretch flex flex-col gap-[6px] grow items-start justify-center min-h-px min-w-px relative shrink-0">
              <div className="content-stretch flex gap-[12px] h-[24px] items-center relative shrink-0 w-full">
                <p
                  className="font-['Noto_Sans:Regular',sans-serif] font-normal leading-[20px] relative shrink-0 text-[#292a2e] text-[14px] text-nowrap whitespace-pre"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  {title}
                </p>
                {badge && (
                  <div className="bg-[rgba(5,21,36,0.06)] box-border content-stretch flex items-center px-[6px] py-0 relative rounded-[8px] shrink-0">
                    <p
                      className="font-['SF_Pro:Regular',sans-serif] font-normal leading-[16px] relative shrink-0 text-[#292a2e] text-[12px] text-center text-nowrap whitespace-pre"
                      style={{ fontVariationSettings: "'wdth' 100" }}
                    >
                      {badge}
                    </p>
                  </div>
                )}
              </div>
              <div className="content-stretch flex flex-col gap-[4px] items-start justify-center relative shrink-0">
                <div
                  className="flex flex-col font-['SF_Pro:Regular',sans-serif] font-normal justify-center leading-[0] relative shrink-0 text-[#6b6e76] text-[12px] text-nowrap"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  <p className="leading-[16px] whitespace-pre">{subtitle}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-[rgba(5,21,36,0.06)] box-border content-stretch flex items-center justify-center min-h-[32px] pl-[12px] pr-[8px] py-0 relative rounded-[3px] shrink-0">
            <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
              <div
                className="flex flex-col font-['Noto_Sans:Medium',sans-serif] font-medium justify-center leading-[0] relative shrink-0 text-[#292a2e] text-[14px] text-center text-nowrap"
                style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
              >
                <p className="leading-[20px] whitespace-pre">Open</p>
              </div>
              <div className="">
                <ChevronDownIcon className="block size-full text-[#292A2E]" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        className="absolute border border-[rgba(11,18,40,0.14)] border-solid inset-0 pointer-events-none"
      />
    </div>
  );
}

// Discover Card Component
function DiscoverCard({
  icon,
  title,
  subtitle,
  description,
  actionText,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  description: string;
  actionText: string;
}) {
  return (
    <div className="relative rounded-[3px] shrink-0 w-full">
      <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
        <div className="box-border content-stretch flex gap-[12px] items-center px-[16px] py-[12px] relative w-full">
          <div className="basis-0 content-stretch flex gap-[12px] grow items-center min-h-px min-w-px relative shrink-0">
            <div className="content-stretch flex items-start relative shrink-0">
              <div className="overflow-clip relative shrink-0 size-[24px]">
                {icon}
              </div>
            </div>
            <div className="basis-0 content-stretch flex flex-col gap-[6px] grow items-start justify-center min-h-px min-w-px relative shrink-0">
              <div className="content-stretch flex gap-[12px] h-[24px] items-center relative shrink-0 w-full">
                <p
                  className="font-['Noto_Sans:Regular',sans-serif] font-normal leading-[20px] relative shrink-0 text-[#292a2e] text-[14px] text-nowrap whitespace-pre"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  {title}
                </p>
              </div>
              <div className="content-stretch flex flex-col font-normal gap-[4px] items-start justify-center leading-[0] relative shrink-0 text-[12px] text-nowrap">
                <div
                  className="flex flex-col font-['SF_Pro:Regular',sans-serif] justify-center relative shrink-0 text-[#6b6e76]"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  <p className="leading-[16px] text-nowrap whitespace-pre">
                    {subtitle}
                  </p>
                </div>
                <div
                  className="flex flex-col font-['Noto_Sans:Regular',sans-serif] justify-center relative shrink-0 text-[#292a2e]"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  <p className="leading-[16px] text-nowrap whitespace-pre">
                    {description}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="box-border content-stretch flex items-center justify-center min-h-[32px] px-[12px] py-0 relative rounded-[3px] shrink-0">
            <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
              <div
                className="flex flex-col font-['Noto_Sans:Medium',sans-serif] font-medium justify-center leading-[0] relative shrink-0 text-[#1868db] text-[0px] text-center text-nowrap"
                style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
              >
                <p
                  className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-solid leading-[20px] text-[14px] underline whitespace-pre"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  {actionText}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        className="absolute border border-[rgba(11,18,40,0.14)] border-solid inset-0 pointer-events-none rounded-[3px]"
      />
    </div>
  );
}

export default function App() {
  const [activeTab, setActiveTab] = useState<
    "worked" | "viewed" | "recommended"
  >("worked");

  const filteredItems = whatsNextData.filter(
    (item) => item.category === activeTab
  );

  return (
    <div className="relative size-full">
      <div className="size-full">
        <div className="box-border content-stretch flex flex-col items-start pb-[32px] pt-[16px] px-[32px] relative size-full">
          {/* Header */}
          <div
            className="relative rounded-[10px] shrink-0 w-full"
            style={{
              backgroundImage:
                "url('data:image/svg+xml;utf8,<svg xmlns=\\\'http://www.w3.org/2000/svg\\\' viewBox=\\\'0 0 1573 164\\\' preserveAspectRatio=\\\'none\\\'><g transform=\\\'matrix(74.145 -23.58 79.213 22.071 1573 164)\\\'><foreignObject x=\\\'-126.49\\\' y=\\\'-126.49\\\' width=\\\'252.98\\\' height=\\\'252.98\\\'><div xmlns=\\\'http://www.w3.org/1999/xhtml\\\' style=\\\'background-image: conic-gradient(from 90deg, rgba(0, 35, 102, 1) 0%, rgba(0, 35, 102, 1) 5.9491%, rgba(11, 45, 110, 1) 10.708%, rgba(21, 55, 119, 1) 15.466%, rgba(43, 75, 136, 1) 24.983%, rgba(40, 77, 148, 1) 36.681%, rgba(25, 55, 113, 1) 48.435%, rgba(11, 34, 78, 1) 60.188%, rgba(30, 58, 112, 1) 62.851%, rgba(49, 82, 146, 1) 65.514%, rgba(24, 58, 124, 1) 70.287%, rgba(12, 47, 113, 1) 72.673%, rgba(0, 35, 102, 1) 75.06%, rgba(11, 34, 78, 1) 87.356%, rgba(30, 58, 112, 1) 89.901%, rgba(49, 82, 146, 1) 92.446%, rgba(24, 58, 124, 1) 96.223%, rgba(12, 47, 113, 1) 98.112%, rgba(0, 35, 102, 1) 100%); opacity:1; height: 100%; width: 100%;\\\'></div></foreignObject></g></svg>')",
            }}
          >
            <div className="size-full">
              <div className="box-border content-stretch flex flex-col items-start p-[20px] relative w-full">
                {/* Breadcrumb */}
                <div className="content-stretch flex gap-[8px] items-start relative shrink-0">
                  <div className="content-stretch flex gap-[8px] items-center min-h-[24px] relative shrink-0">
                    <div className="content-stretch flex items-center relative shrink-0">
                      <div
                        className="flex flex-col font-['Noto_Sans:Regular',sans-serif] font-normal justify-center leading-[0] relative shrink-0 text-[14px] text-center text-nowrap text-white"
                        style={{
                          fontVariationSettings: "'CTGR' 0, 'wdth' 100",
                        }}
                      >
                        <p className="leading-[20px] whitespace-pre">
                          {new Date().toLocaleDateString("en-US", {
                            weekday: "long",
                            month: "long",
                            day: "numeric",
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Title */}
                <div className="box-border content-stretch flex items-start pb-[8px] pt-0 px-0 relative shrink-0 w-full">
                  <p
                    className="basis-0 font-['Noto_Sans:SemiCondensed',sans-serif] font-[653] grow leading-[28px] min-h-px min-w-px relative shrink-0 text-[24px] text-white"
                    style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 87.5" }}
                  >
                    Hello, John Doe
                  </p>
                </div>

                {/* Badges */}
                <div className="content-stretch flex gap-[4px] items-start relative shrink-0">
                  <div className="bg-[#e9f2fe] box-border content-stretch flex items-center justify-center px-[6px] py-0 relative rounded-[8px] shrink-0">
                    <p
                      className="font-['SF_Pro:Regular',sans-serif] font-normal leading-[16px] relative shrink-0 text-[#292a2e] text-[12px] text-center text-nowrap whitespace-pre"
                      style={{ fontVariationSettings: "'wdth' 100" }}
                    >
                      Jaguar - topsides + hull (POC)
                    </p>
                  </div>
                  <div className="bg-[#e9f2fe] box-border content-stretch flex items-center justify-center px-[6px] py-0 relative rounded-[8px] shrink-0">
                    <p
                      className="font-['SF_Pro:Regular',sans-serif] font-normal leading-[16px] relative shrink-0 text-[#292a2e] text-[12px] text-center text-nowrap whitespace-pre"
                      style={{ fontVariationSettings: "'wdth' 100" }}
                    >
                      Workfront ready: 42 spools
                    </p>
                  </div>
                  <div className="bg-[#e9f2fe] box-border content-stretch flex items-center justify-center px-[6px] py-0 relative rounded-[8px] shrink-0">
                    <p
                      className="font-['SF_Pro:Regular',sans-serif] font-normal leading-[16px] relative shrink-0 text-[#292a2e] text-[12px] text-center text-nowrap whitespace-pre"
                      style={{ fontVariationSettings: "'wdth' 100" }}
                    >
                      Materials:12
                    </p>
                  </div>
                  <div className="bg-[#e9f2fe] box-border content-stretch flex items-center justify-center px-[6px] py-0 relative rounded-[8px] shrink-0">
                    <p
                      className="font-['SF_Pro:Regular',sans-serif] font-normal leading-[16px] relative shrink-0 text-[#292a2e] text-[12px] text-center text-nowrap whitespace-pre"
                      style={{ fontVariationSettings: "'wdth' 100" }}
                    >
                      Critical punches: 3
                    </p>
                  </div>
                </div>

                {/* Bottom Bar */}
                <div className="box-border content-stretch flex gap-[8px] items-center pb-0 pt-[16px] px-0 shrink-0 w-full">
                  <HeaderButton
                    icon={
                      <AnalyticsIcon className="size-full text-foreground" />
                    }
                    label="Analytics"
                  />
                  <HeaderButton
                    icon={
                      <ThreeDVisualizationIcon className="size-full text-foreground" />
                    }
                    label="3D Visualization"
                  />
                  <HeaderButton
                    icon={
                      <DataExplorationIcon className="size-full text-foreground" />
                    }
                    label="Data exploration"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Frequently Visited Section */}
          <div className="box-border content-stretch flex items-center pb-[8px] pt-[16px] px-0 relative shrink-0 w-full">
            <div className="basis-0 content-stretch flex flex-col grow items-center justify-center min-h-px min-w-px relative shrink-0">
              <p
                className="font-['Noto_Sans:SemiCondensed',sans-serif] font-[653] leading-[24px] relative shrink-0 text-[#424242] text-[20px] w-full"
                style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 87.5" }}
              >
                Frequently visited
              </p>
            </div>
          </div>

          <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
            <div className="content-stretch flex gap-[8px] items-start relative shrink-0 w-full">
              <FrequentlyVisitedCard
                icon={
                  <div className="absolute aspect-[18/18] bottom-[8.33%] left-[2px] top-[8.33%]">
                    <Box3DIcon className="block size-full text-[#292A2E]" />
                  </div>
                }
                title="Full FPSO model"
                subtitle="Jaguar project • 3D Visualization"
                link="https://kxd-demo.konnectxd.com/3d-visualization/full-fpso"
              />
              <FrequentlyVisitedCard
                icon={
                  <div className="absolute aspect-[18/18] left-[8.33%] right-[8.33%] top-[2px]">
                    <TableIcon className="block size-full text-[#292A2E]" />
                  </div>
                }
                title="Datasheet: 662-VES-0010"
                subtitle="Jaguar project • Tag explorer • Data exploration"
              />
              <FrequentlyVisitedCard
                icon={
                  <div className="absolute aspect-[18/18] left-[8.33%] right-[8.33%] top-[2px]">
                    <ChartBarIcon className="block size-full text-[#292A2E]" />
                  </div>
                }
                title="Readiness heatmap"
                subtitle="Jaguar project • Analysis"
              />
            </div>
          </div>

          {/* What's Next Section */}
          <div className="box-border content-stretch flex items-center pb-[8px] pt-[16px] px-0 relative shrink-0 w-full">
            <div className="basis-0 content-stretch flex flex-col grow items-center justify-center min-h-px min-w-px relative shrink-0">
              <p
                className="font-['Noto_Sans:SemiCondensed',sans-serif] font-[653] leading-[24px] relative shrink-0 text-[#424242] text-[20px] w-full"
                style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 87.5" }}
              >{`What's next`}</p>
            </div>
            <div className="box-border content-stretch flex gap-[4px] items-center p-[5px] relative shrink-0">
              <div
                aria-hidden="true"
                className="absolute border border-[rgba(66,66,66,0.14)] border-solid inset-0 pointer-events-none"
              />
              <button
                onClick={() => setActiveTab("worked")}
                className={`${
                  activeTab === "worked"
                    ? "bg-[#e9f2fe]"
                    : "bg-[rgba(5,21,36,0.06)]"
                } box-border content-stretch flex items-center justify-center min-h-[32px] px-[12px] py-0 relative rounded-[3px] shrink-0 cursor-pointer hover:opacity-80 transition-all border-0`}
              >
                <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
                  <div
                    className={`flex flex-col font-['Noto_Sans:Medium',sans-serif] font-medium justify-center leading-[0] relative shrink-0 ${
                      activeTab === "worked"
                        ? "text-[#1868db]"
                        : "text-[#292a2e]"
                    } text-[14px] text-center text-nowrap`}
                    style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                  >
                    <p className="leading-[20px] whitespace-pre">Worked on</p>
                  </div>
                </div>
              </button>
              <button
                onClick={() => setActiveTab("viewed")}
                className={`${
                  activeTab === "viewed"
                    ? "bg-[#e9f2fe]"
                    : "bg-[rgba(5,21,36,0.06)]"
                } box-border content-stretch flex items-center justify-center min-h-[32px] px-[12px] py-0 relative rounded-[3px] shrink-0 cursor-pointer hover:opacity-80 transition-all border-0`}
              >
                <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
                  <div
                    className={`flex flex-col font-['Noto_Sans:Medium',sans-serif] font-medium justify-center leading-[0] relative shrink-0 ${
                      activeTab === "viewed"
                        ? "text-[#1868db]"
                        : "text-[#292a2e]"
                    } text-[14px] text-center text-nowrap`}
                    style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                  >
                    <p className="leading-[20px] whitespace-pre">Viewed</p>
                  </div>
                </div>
              </button>
              <button
                onClick={() => setActiveTab("recommended")}
                className={`${
                  activeTab === "recommended"
                    ? "bg-[#e9f2fe]"
                    : "bg-[rgba(5,21,36,0.06)]"
                } box-border content-stretch flex items-center justify-center min-h-[32px] px-[12px] py-0 relative rounded-[3px] shrink-0 cursor-pointer hover:opacity-80 transition-all border-0`}
              >
                <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
                  <div
                    className={`flex flex-col font-['Noto_Sans:Medium',sans-serif] font-medium justify-center leading-[0] relative shrink-0 ${
                      activeTab === "recommended"
                        ? "text-[#1868db]"
                        : "text-[#292a2e]"
                    } text-[14px] text-center text-nowrap`}
                    style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                  >
                    <p className="leading-[20px] whitespace-pre">Recommended</p>
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* What's Next Card */}
          <div className="bg-white relative rounded-[3px] shrink-0 w-full">
            <div className="content-stretch flex flex-col items-center overflow-clip relative rounded-[inherit] w-full">
              <div className="content-stretch flex items-start relative shrink-0 w-full">
                <div className="basis-0 content-stretch flex flex-col grow items-start min-h-px min-w-px relative self-stretch shrink-0">
                  {filteredItems.map((item) => (
                    <WhatsNextItem
                      key={item.id}
                      icon={item.icon}
                      title={item.title}
                      subtitle={item.subtitle}
                      actionText={item.actionText}
                      time={item.time}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div
              aria-hidden="true"
              className="absolute border border-[rgba(11,18,40,0.14)] border-solid inset-[-1px] pointer-events-none rounded-[4px]"
            />
          </div>

          {/* Recent Projects Section */}
          <div className="box-border content-stretch flex items-center pb-[8px] pt-[16px] px-0 relative shrink-0 w-full">
            <div className="basis-0 content-stretch flex flex-col grow items-center justify-center min-h-px min-w-px relative shrink-0">
              <p
                className="font-['Noto_Sans:SemiCondensed',sans-serif] font-[653] leading-[24px] relative shrink-0 text-[#424242] text-[20px] w-full"
                style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 87.5" }}
              >
                Recent project
              </p>
            </div>
          </div>

          <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
            <div className="content-stretch flex gap-[8px] items-start relative shrink-0 w-full">
              <RecentProjectCard
                title="FPSO Jaguar"
                subtitle="Offshore • FPSO"
              />
              <RecentProjectCard
                title="Woodfibre LNG"
                subtitle="Onshore • LNG"
                badge="Placeholder"
              />
              <RecentProjectCard
                title="ITER"
                subtitle="Nuclear • France"
                badge="Placeholder"
              />
            </div>
          </div>

          {/* Discover Section */}
          <div className="box-border content-stretch flex items-center pb-[8px] pt-[16px] px-0 relative shrink-0 w-full">
            <div className="basis-0 content-stretch flex flex-col grow items-center justify-center min-h-px min-w-px relative shrink-0">
              <p
                className="font-['Noto_Sans:SemiCondensed',sans-serif] font-[653] leading-[24px] relative shrink-0 text-[#424242] text-[20px] w-full"
                style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 87.5" }}
              >{`Discover what's happening`}</p>
            </div>
          </div>

          <div className="content-stretch flex flex-col gap-[12px]  pb-[32px] items-start justify-center relative shrink-0 w-full">
            <DiscoverCard
              icon={
                <div className="absolute left-[2px] size-[20px] top-[2px]">
                  <LayoutStudioIcon className="block size-full text-[#292A2E]" />
                </div>
              }
              title="Layout Studio: Deck U7 changes (diff view)"
              subtitle="Owned by Raiven • 1 day ago • Layout Studio"
              description="2 zones moved; 5 equipment footprints adjusted. Approval needed."
              actionText="Review"
            />
            <DiscoverCard
              icon={
                <div className="absolute aspect-[18/18] bottom-[8.33%] left-[2px] top-[8.33%]">
                  <QHSEIcon className="block size-full text-[#292A2E]" />
                </div>
              }
              title='QHSE POIs: New "Hot Work" category'
              subtitle="Owned by QHSE Team • 4 days ago • 3D Visualization"
              description="Adds checklist + tolerance rules; links to weld areas in U7."
              actionText="Learn more"
            />
            <div className="bg-[rgba(5,21,36,0.06)] box-border content-stretch flex items-center justify-center min-h-[32px] px-[12px] py-0 relative rounded-[3px] shrink-0">
              <div className="content-stretch flex gap-[4px] items-center justify-center relative shrink-0">
                <div
                  className="flex flex-col font-['Noto_Sans:Medium',sans-serif] font-medium justify-center leading-[0] relative shrink-0 text-[#292a2e] text-[14px] text-center text-nowrap"
                  style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
                >
                  <p className="leading-[20px] whitespace-pre">View all</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
